import { render, staticRenderFns } from "./ui-observe-visibility.vue?vue&type=template&id=45b19a2c&"
import script from "./ui-observe-visibility.vue?vue&type=script&lang=ts&"
export * from "./ui-observe-visibility.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports